import React, { useState } from 'react'
import PropTypes from 'prop-types'
import firebase from 'firebase/app'
import { connect } from 'react-redux'

import { setSnackError, setSnackSuccess } from '../actions/app'
import Button from '../components/Button'
import Loading from '../components/Loading'
import Section from '../components/Section'
import Breadcrumb from '../components/Breadcrumb'


const PageAdminTasks = ({
  setSnackError: setSnackErrorAction,
  setSnackSuccess: setSnackSuccessAction,
}) => {
  const [isLoading, setIsLoading] = useState(false)

  const handlePopulateTransactionsWithRefund = async () => {
    setIsLoading(true)

    try {
      const functions = firebase.functions()

      await functions.httpsCallable('triggerAdminTasks')({ populateTransactionRefund: true })
      setSnackSuccessAction('Les transactions ont bien été mise à jour')
    } catch (err) {
      console.error(err)
      setSnackErrorAction(err.message)
    }

    setIsLoading(false)
  }

  const handlePopulateUsersWithLastWalletExpiration = async () => {
    setIsLoading(true)

    try {
      const functions = firebase.functions()

      await functions.httpsCallable('triggerAdminTasks')({ populateUserLastWalletExpiration: true })
      setSnackSuccessAction('Les utilisateurs ont bien été mise à jour')
    } catch (err) {
      console.error(err)
      setSnackErrorAction(err.message)
    }

    setIsLoading(false)
  }

  const handlePopulateWalletExpiration = async () => {
    setIsLoading(true)

    try {
      const functions = firebase.functions()

      await functions.httpsCallable('triggerAdminTasks')({ populateWalletExpiration: true })
      setSnackSuccessAction('Les wallets expirés ont bien été mise à jour')
    } catch (err) {
      console.error(err)
      setSnackErrorAction(err.message)
    }

    setIsLoading(false)
  }

  return (
    <div>
      <Breadcrumb
        data={[
          { label: 'Accueil', to: '/' },
          'Administration',
        ]}
      />

      {isLoading && <Loading />}

      <Section
        disableArrow
        title="Admin Tasks"
      >
        <Button
          fullWidth
          isLoading={isLoading}
          onClick={handlePopulateTransactionsWithRefund}
        >
          Mettre à jour les infos de transactions pour le refund
        </Button>

        <br /><br />
        <Button
          fullWidth
          isLoading={isLoading}
          onClick={handlePopulateUsersWithLastWalletExpiration}
        >
          Mettre à jour les users avec Last wallet expiration
        </Button>

        <br /><br />
        <Button
          fullWidth
          isLoading={isLoading}
          onClick={handlePopulateWalletExpiration}
        >
          Mettre à jour les wallets expirés
        </Button>
      </Section>
    </div>
  )
}


PageAdminTasks.propTypes = {
  setSnackError: PropTypes.func.isRequired,
  setSnackSuccess: PropTypes.func.isRequired,
}


export default connect(null, {
  setSnackSuccess,
  setSnackError,
})(PageAdminTasks)
